import type { PortalEstimate } from "../../../lib/portal";

/**
 * The word on a quote's badge.
 *
 * `answerState` wins over `status` for exactly one case: a live quote whose
 * date has gone by. Nothing in the CRM ever writes `EstimateStatus.expired`, so
 * such a quote still arrives with `status: "sent"`, and printing that would
 * leave a quote that looks open sitting next to no buttons at all - and the
 * client writes in to ask why. The server's answer is taken as it came; this
 * is not a second copy of the date rule.
 */
export function shownStatus(est: Pick<PortalEstimate, "status" | "answerState">): string {
  return est.answerState === "expired" ? "expired" : est.status;
}
